document.addEventListener('DOMContentLoaded', function() {
  const sidecart = document.getElementById('sidecart');
  const overlay = document.getElementById('sidecart-overlay');
  const closeBtn = document.querySelector('.sidecart-close');
  const cartIcon = document.querySelector('[data-sidecart-open]'); // Add this attribute to your cart icon
  const itemsContainer = document.getElementById('sidecart-items');
  const countEl = document.getElementById('sidecart-count');
  const totalEl = document.getElementById('sidecart-total-price');
  const checkoutBtn = document.getElementById('sidecart-checkout');
  const spinner = document.getElementById('sidecart-spinner');

  // Helper to show/hide spinner
  function showSpinner() { spinner.style.display = 'flex'; }
  function hideSpinner() { spinner.style.display = 'none'; }

  // _birthday_gift is set by birthday-gift-drop.js (CNV-3010); the other two
  // come from the gift-with-purchase apps.
  const FREE_GIFT_PROPERTY_KEYS = ['_Gifted', '_igGWP', '_birthday_gift'];

  function isFreeGiftItem(item) {
    const props = item?.properties;
    if (!props) return false;
    return FREE_GIFT_PROPERTY_KEYS.some((key) => props[key]);
  }

  // Store last cart for revert
  let lastCart = null;
  let isCartUpdating = false; // Flag to prevent multiple simultaneous cart operations
  let fetchCartTimeout = null; // For debouncing fetchCart calls

  function openSidecart() {
    sidecart.classList.add('open');
    overlay.classList.add('open');
    document.body.classList.add('no-scroll');
    fetchCart();
  }
  function closeSidecart() {
    sidecart.classList.remove('open');
    overlay.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }

  // Open/close events
  if (cartIcon) cartIcon.addEventListener('click', openSidecart);
  closeBtn.addEventListener('click', closeSidecart);
  overlay.addEventListener('click', closeSidecart);
     const productTagCache = {};

    function getProductTags(handle) {
      if (productTagCache[handle]) {
        return productTagCache[handle];
      }

      const tags =
        (window.MOZIWASH_PRODUCT_TAGS && window.MOZIWASH_PRODUCT_TAGS[handle]) || [];
      productTagCache[handle] = tags;
      return tags;
    }

    function rankSellingPlanName(name) {
      const lower = String(name || '').toLowerCase();
      const m = lower.match(/(\d+(?:\.\d+)?)\s*(day|week|month|year)?/i);
      if (!m) return Number.POSITIVE_INFINITY;
      const num = parseFloat(m[1]);
      const unit = (m[2] || 'week').toLowerCase();
      const factor =
        unit.startsWith('day') ? 1 :
        unit.startsWith('week') ? 7 :
        unit.startsWith('month') ? 30 :
        unit.startsWith('year') ? 365 : 7;
      return num * factor;
    }

    function getSortedSellingPlans(variantId) {
      const sellingPlans =
        (window.MOZIWASH_SELLING_PLANS && window.MOZIWASH_SELLING_PLANS[variantId]) || [];
      return [...sellingPlans].sort((a, b) => {
        const ra = rankSellingPlanName(a.name);
        const rb = rankSellingPlanName(b.name);
        if (ra !== rb) return ra - rb;
        return String(a.name).localeCompare(String(b.name));
      });
    }

    function getDefaultSellingPlanId(variantId) {
      const sortedPlans = getSortedSellingPlans(variantId);
      // Product default cadence (custom.default_selling_plan), otherwise the shortest plan
      const defaultPlan = sortedPlans.find((plan) => plan.default) || sortedPlans[0];
      return defaultPlan?.id || null;
    }

    function resolveCart() {
      if (lastCart && Array.isArray(lastCart.items)) {
        return Promise.resolve(lastCart);
      }
      return fetch('/cart.js').then((res) => res.json());
    }
  /**
   * A body that is safe to paint. renderCart empties itemsContainer before it
   * rebuilds, so anything that is not a whole cart would leave the shopper
   * looking at an empty drawer — callers fall back to fetchCart() instead.
   */
  function isFullCart(body) {
    return !!(
      body &&
      Array.isArray(body.items) &&
      (body.token !== undefined || body.item_count !== undefined)
    );
  }

  /**
   * Paint a cart we already hold. change.js and update.js both answer with the
   * whole cart, so every caller of those has one in hand and does not need to
   * go read /cart.js back — that read was costing a second serial round trip on
   * every quantity click. add.js answers with only the lines it created, so
   * those callers still go through fetchCart.
   */
  function applyCart(cart) {
    lastCart = JSON.parse(JSON.stringify(cart)); // Deep copy for revert
    renderCart(cart);
    // Every cart flow funnels through here right before the shopper sees
    // the result — THE "cart settled" signal (birthday-gift-drop.js keys
    // off it).
    document.dispatchEvent(
      new CustomEvent('mozi:cart:updated', { detail: { cart: cart } })
    );
  }

  /** Paint a mutation's own response, falling back to a read if it is not one. */
  function applyCartResponse(body) {
    if (!isFullCart(body)) return fetchCart();
    applyCart(body);
    return Promise.resolve();
  }

  // Fetch cart data
  function fetchCart() {
    // Clear any pending timeout
    if (fetchCartTimeout) {
      clearTimeout(fetchCartTimeout);
    }
    
    // If already updating, schedule a retry
    if (isCartUpdating) {
      fetchCartTimeout = setTimeout(() => fetchCart(), 100);
      return Promise.resolve();
    }
    
    isCartUpdating = true;
    showSpinner();
    
    return fetch('/cart.js')
      .then(res => res.json())
      .then(applyCart)
      .catch(error => {
        // renderCart clears the item container before it rebuilds it, so a
        // throw anywhere in the middle leaves the shopper looking at an empty
        // cart drawer. Swallowing that silently makes it unfindable.
        console.error('[sidecart] cart render failed:', error);
      })
      .finally(() => {
        hideSpinner();
        isCartUpdating = false;
      });
  }

  // Render cart items
  function renderCart(cart) {
    countEl.textContent = cart.item_count;
    // Update header cart count bubble
    const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (cartCountBubble) {
      cartCountBubble.textContent = cart.item_count;
    }
    // Calculate original total (before discounts)
    let originalTotal = 0;
    let oneTimeCount = 0;
    cart.items.forEach(item => {
      originalTotal += item.original_line_price;
      if (!item.selling_plan_allocation) {
        oneTimeCount++;
      }
    });
    const hasOneTime = oneTimeCount > 0;
    const hasMultipleItems = cart.items.length >= 2;
    const totalCompareEl = document.querySelector('.sidecart-total-compare');
    if (totalCompareEl) {
      if (originalTotal > cart.total_price) {
        totalCompareEl.textContent = Shopify.formatMoney(originalTotal);
        totalCompareEl.style.display = '';
        // Calculate and show total savings
        const totalDiscountEl = document.querySelector('.sidecart-total-discount');
        if (totalDiscountEl) {
          const savings = originalTotal - cart.total_price;
          totalDiscountEl.textContent = `Total Savings ${Shopify.formatMoney(savings)}`;
          totalDiscountEl.style.display = 'inline';
        }
      } else {
        totalCompareEl.style.display = 'none';
        // Hide savings if no discount
        const totalDiscountEl = document.querySelector('.sidecart-total-discount');
        if (totalDiscountEl) {
          totalDiscountEl.style.display = 'none';
        }
      }
    }
    totalEl.textContent = Shopify.formatMoney(cart.total_price);
    itemsContainer.innerHTML = '';
    // Hide/show sections based on cart state
    const footer = document.querySelector('.sidecart-footer');
    const otprogress = document.querySelector('.onetime-progress-bar');
    const progress = document.querySelector('.sidecart-progress-section');
    const recommend = document.querySelector('.sidecart-recommend-section');
    const recommend_title = document.querySelector('.sidecart-recommend-title');
    const bestsellers = document.getElementById('sidecart-bestsellers-section');
    const usp = document.querySelector('.sidecart-usps');
    const timerSection = document.querySelector('.sidecart-timer-section');

    if (cart.items.length === 0) {
  setTimeout(() => {
  if (otprogress) otprogress.style.display = 'none';
  if (progress) progress.style.display = 'none';
 }, 10);
      if (footer) footer.style.display = 'none';
      if (progress) progress.style.display = 'none';
      if (recommend) recommend.style.display = 'none';
      if (recommend_title) recommend_title.style.display = 'none';
      if (bestsellers) bestsellers.style.display = '';
      if (usp) usp.style.display = 'none';
      if (timerSection) timerSection.style.display = 'none';
   
      // updateProgressBarContent(cart);
      updateProgressBar(cart);
      return;
    } else {
      if (footer) footer.style.display = '';
      if (progress) progress.style.display = '';
      if (otprogress) otprogress.style.display = '';
      if (recommend) recommend.style.display = '';
      if (recommend_title) recommend_title.style.display = '';
      if (bestsellers) bestsellers.style.display = 'none';
      if (usp) usp.style.display = '';
      if (timerSection) timerSection.style.display = '';
        updateProgressBar(cart);
    }
    // Segregate bundle and non-bundle items
    const bundleItems = [];
    const nonBundleItems = [];
    cart.items.forEach(item => {
      const hasBundleId = item.properties && Object.keys(item.properties).some(
        key => key === '_unique_id' && item.properties[key]
      );
      if (hasBundleId) {
        bundleItems.push(item);
      } else {
        nonBundleItems.push(item);
      }
    });
    // Group bundle items by _unique_id
    const bundlesById = {};
    const uniquebundleids = {};
    bundleItems.forEach(item => {
      const bundleId = item.properties['_unique_id'];
      // if (uniquebundleids[bundleId]){
      //   return;
      // }
      // else{
      //   uniquebundleids[bundleId] = true;
      // }
      if (!bundleId) return;
      if (!bundlesById[bundleId]) bundlesById[bundleId] = [];
      bundlesById[bundleId].push(item);
    });
    // Render bundles
    Object.keys(bundlesById).forEach(bundleId => {
      const bundle = bundlesById[bundleId];
      const firstItem = bundle[0];
      // Calculate prices
      let bundleFinalPrice;
let bundleOriginalPrice;

if (firstItem.properties && firstItem.properties._bundle_items) {
  //  Your custom bundle — calculate total price from items in bundle
  bundleFinalPrice = bundle.reduce((sum, item) => sum + item.final_line_price, 0);
  bundleOriginalPrice = bundle.reduce((sum, item) => sum + item.original_line_price, 0);
} else {
  //  Default/legacy logic — assume only single item price shown
  bundleFinalPrice = firstItem.final_line_price;
  bundleOriginalPrice = firstItem.original_line_price;
}

      const isSubscription = !!firstItem.selling_plan_allocation;
      const tag = isSubscription
        ? `<span class="sidecart-item-tag subscription">Subscription</span>`
        : `<span class="sidecart-item-tag onetime">One-Time</span>`;
      const compareAt = bundleOriginalPrice > bundleFinalPrice
        ? `<span class="sidecart-item-price-compare">${Shopify.formatMoney(bundleOriginalPrice)}</span>`
        : '';
      // Bundle dropdown content
      const uniquebundlebuilder = {};
      const uniquebundlearray= bundle.slice(0,1);
   const bundleItemsList = uniquebundlearray.map((item, index) => {
    let uniquebundlebuilderid = item.properties?.['_unique_id'];
    if (uniquebundlebuilder[uniquebundlebuilderid]){
      return;
    }
    if(item.properties?.["Included Products"] && !uniquebundlebuilder[uniquebundlebuilderid])
     {
   
  const includedProducts = item.properties?.["Included Products"];
  if (includedProducts) {
    // If bundle, split comma-separated titles
    const productsArray = includedProducts.split(',').map(name => name.trim());
    return productsArray.map(productName => 
      `<li class="font-degular">${productName} x ${item.quantity}</li>`
    ).join('');
  } else {
    // Fallback for single products
    const optionName = item.options_with_values?.[0]?.value || item.product_title;
    return `<li class="font-degular">${optionName} x ${item.quantity}</li>`;
  }}
  else {
   uniquebundlebuilder[uniquebundlebuilderid]= true;
  }
}).join('');
    

      // Bundle block
      const bundleDiv = document.createElement('div');
      bundleDiv.className = 'sidecart-item sidecart-bundle-group';
      bundleDiv.innerHTML = `
        <div class="sidecart-item-img"><img src="${firstItem.image}" alt="Custom Bundle" width="60"></div>
        <div class="sidecart-item-info">
          <div class="sidecart-title-price-row">
            <div class="sidecart-item-title-row">
              <span class="sidecart-bundle-title-row">
              ${firstItem.properties?.["Bundle Name"]
  ? `<span class="sidecart-item-title">${firstItem.properties["Bundle Name"]}</span>`
  : `<span class="sidecart-item-title">Mozi Wash Signature Detergent</span>`}
${tag}

         

              ${isSubscription && firstItem.selling_plan_allocation ? `<div class="bundle-selling-plan">${firstItem.selling_plan_allocation.selling_plan.name}</div>` : ''}
              </span>
            </div>
            <div class="sidecart-item-price-row">
              <span class="sidecart-item-price">${Shopify.formatMoney(bundleFinalPrice)}</span>
              ${compareAt}
            </div>
          </div>
          
   ${(!isSubscription && !(firstItem.properties && firstItem.properties._addon_item)) ? `
  <div class="bundle-subscribe-btn-wrapper">
    <button 
      class="bundle-subscribe-now-btn" 
      data-unique-id="${firstItem.properties?._unique_id || ''}">
      Subscribe and save big
    </button>
  </div>
` : ''}

          <div class="sidecart-bundle-details-row testing">
            <div class="sidecart-bundle-dropdown">
              <button class="sidecart-bundle-dropdown-toggle font-degular" style="display:none;">ITEMS INCLUDED 
                <span class="dropdown-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7073 15.7069C12.5198 15.8943 12.2655 15.9996 12.0003 15.9996C11.7352 15.9996 11.4809 15.8943 11.2933 15.7069L5.63634 10.0499C5.54083 9.95761 5.46465 9.84726 5.41224 9.72526C5.35983 9.60326 5.33225 9.47204 5.33109 9.33926C5.32994 9.20648 5.35524 9.0748 5.40552 8.9519C5.4558 8.829 5.53006 8.71735 5.62395 8.62346C5.71784 8.52957 5.82949 8.45531 5.95239 8.40503C6.07529 8.35475 6.20696 8.32945 6.33974 8.3306C6.47252 8.33176 6.60374 8.35934 6.72575 8.41175C6.84775 8.46416 6.9581 8.54034 7.05034 8.63585L12.0003 13.5859L16.9503 8.63585C17.1389 8.4537 17.3915 8.3529 17.6537 8.35518C17.9159 8.35746 18.1668 8.46263 18.3522 8.64804C18.5376 8.83344 18.6427 9.08426 18.645 9.34645C18.6473 9.60865 18.5465 9.86125 18.3643 10.0499L12.7073 15.7069Z" fill="#262525"/>
                  </svg>
                </span>
              </button>
              <ul class="sidecart-bundle-items-list">
                ${bundleItemsList}
              </ul>
            </div>
            <button class="remove-bundle-btn" data-bundle-id="${bundleId}" data-unique-id="${bundleId}" title="Remove bundle">
              <img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/mozi-cart--delete-icon.svg?v=1749934844" alt="Remove" width="18" height="18">
            </button>
          </div>
        </div>
      `;
      itemsContainer.appendChild(bundleDiv);
    });
    attachBundleSubscribeNowHandler();
////////////////////////////////////////////////
// Cart subscribe now button js start here for Bundle products
function attachBundleSubscribeNowHandler() {
  document.querySelectorAll('.bundle-subscribe-now-btn').forEach(btn => {
    btn.addEventListener('click', handleBundleSubscribeNowClick);
  });
}

function handleBundleSubscribeNowClick(e) {
  const btn = e.currentTarget;
  const uniqueId = btn.dataset.uniqueId;

  btn.disabled = true;
  btn.textContent = 'Updating...';
  showSpinner();

  resolveCart()
    .then(cart => {
      const bundleItems = cart.items.filter(item =>
        item.properties && item.properties._unique_id === uniqueId
      );

      if (!bundleItems.length) throw new Error('No bundle items found in cart.');

      // Selling plans are already shipped via MOZIWASH_SELLING_PLANS — no per-line product.js
      const itemsWithPlans = bundleItems.map(item => {
        const planId = getDefaultSellingPlanId(item.variant_id);
        if (!planId) throw new Error(`No selling plan for ${item.handle}`);
        return { ...item, planId };
      });

      return itemsWithPlans;
    })
    .then(itemsWithPlans => {

      // Build a cart update object to remove old items first
      const updates = {};
      itemsWithPlans.forEach(item => {
        updates[item.key] = 0;
      });

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      }).then(() => itemsWithPlans);
    })
    .then(itemsWithPlans => {
      // Add items back with subscription — remove "Purchase Type" property
      const itemsToAdd = itemsWithPlans.map(item => {
        const newProps = { ...item.properties };
        delete newProps["Purchase Type"]; // remove one-time label

        return {
          id: item.variant_id,
          quantity: item.quantity,
          selling_plan: item.planId,
          properties: newProps
        };
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd })
      });
    })
    .then(() => {
      fetchCart(); // refresh cart drawer or page
      hideSpinner();
    })
    .catch(err => {
      console.error('Error updating bundle to subscription:', err);
      btn.textContent = 'Error';
      btn.disabled = false;
      hideSpinner();
    });
}
// Cart subscribe now button js end here for Bundle products

//////////////////////////////////////////

    // Add dropdown and delete logic for bundles
    itemsContainer.querySelectorAll('.sidecart-bundle-dropdown-toggle').forEach(btn => {
      btn.addEventListener('click', function() {
        const dropdown = this.closest('.sidecart-bundle-dropdown');
        const list = dropdown.querySelector('.sidecart-bundle-items-list');
        const isOpen = list.style.display === 'block';
        list.style.display = isOpen ? 'none' : 'block';
        dropdown.classList.toggle('open', !isOpen);
      });
    });
    itemsContainer.querySelectorAll('.remove-bundle-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const bundleId = this.getAttribute('data-bundle-id');
        if (!bundleId) return;
        // Remove all items in this bundle by setting their quantity to 0 in a single request
        const bundle = bundlesById[bundleId];
        if (!bundle) return;
        const updates = Object.fromEntries(bundle.map(item => [item.key, 0]));
        // The spinner used to come from fetchCart; now that update.js paints its
        // own response, this path has to raise it itself.
        showSpinner();
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        })
          .then(res => {
            if (!res.ok) throw new Error('Bundle removal failed');
            return res.json();
          })
          .then(applyCartResponse)
          .catch(() => fetchCart())
          .finally(hideSpinner);
      });
    });
    // Split nonBundleItems into real items and addon items
    const realNonBundleItems = nonBundleItems.filter(item => !isFreeGiftItem(item));
    const addonNonBundleItems = nonBundleItems.filter(item => isFreeGiftItem(item));
    // Render real items first, then addons
    [...realNonBundleItems, ...addonNonBundleItems].forEach(item => {
      const isSubscription = !!item.selling_plan_allocation;
      const tag = item.selling_plan_allocation ? 
        `<span class="sidecart-item-tag subscription">Subscription</span>` : 
        `<span class="sidecart-item-tag onetime">One-time</span>`;
      const compareAt = item.original_line_price > item.final_line_price ? 
        `<span class="sidecart-item-price-compare">${Shopify.formatMoney(item.original_line_price)}</span>` : '';
      let sellingPlanDropdown = '';
      // Default to an empty list: MOZIWASH_SELLING_PLANS only carries the
      // variants the theme knows about, so anything outside it — a new or
      // unlisted product, a free gift — comes back undefined. This is read
      // unguarded further down, and renderCart clears the drawer before it
      // rebuilds it, so one missing variant emptied the whole cart.
      const sellingPlans =
        (window.MOZIWASH_SELLING_PLANS && window.MOZIWASH_SELLING_PLANS[item.variant_id]) || [];
      // if (isSubscription && sellingPlans && sellingPlans.length > 0) {
      //   const selectedPlanId = item.selling_plan_allocation.selling_plan.id;
      //   sellingPlanDropdown = `
      //     <select class="sidecart-selling-plan-select visually-hidden" data-key="${item.key}">
      //       ${sellingPlans.map(plan => `<option value="${plan.id}"${plan.id === selectedPlanId ? ' selected' : ''}>${plan.name}</option>`).join('')}
      //     </select>
      //     <div class="custom-dropdown" data-key="${item.key}">
      //       <button class="custom-dropdown-selected font-degular">${selectedPlanId ? sellingPlans.find(plan => plan.id === selectedPlanId).name : sellingPlans[0].name}
      //         <span class="dropdown-arrow">
      //           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      //             <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7073 15.7069C12.5198 15.8943 12.2655 15.9996 12.0003 15.9996C11.7352 15.9996 11.4809 15.8943 11.2933 15.7069L5.63634 10.0499C5.54083 9.95761 5.46465 9.84726 5.41224 9.72526C5.35983 9.60326 5.33225 9.47204 5.33109 9.33926C5.32994 9.20648 5.35524 9.0748 5.40552 8.9519C5.4558 8.829 5.53006 8.71735 5.62395 8.62346C5.71784 8.52957 5.82949 8.45531 5.95239 8.40503C6.07529 8.35475 6.20696 8.32945 6.33974 8.3306C6.47252 8.33176 6.60374 8.35934 6.72575 8.41175C6.84775 8.46416 6.9581 8.54034 7.05034 8.63585L12.0003 13.5859L16.9503 8.63585C17.1389 8.4537 17.3915 8.3529 17.6537 8.35518C17.9159 8.35746 18.1668 8.46263 18.3522 8.64804C18.5376 8.83344 18.6427 9.08426 18.645 9.34645C18.6473 9.60865 18.5465 9.86125 18.3643 10.0499L12.7073 15.7069Z" fill="#262525"/>
      //           </svg>
      //         </span>
      //       </button>
      //       <ul class="custom-dropdown-list" style="display:none;">
      //         ${sellingPlans.map(plan => `<li class="custom-dropdown-option" data-value="${plan.id}">${plan.name}</li>`).join('')}
      //       </ul>
      //     </div>
      //   `;
      // }
      if (isSubscription && Array.isArray(sellingPlans) && sellingPlans.length > 0) {
  const sortedPlans = getSortedSellingPlans(item.variant_id);

  const selectedPlanId = item?.selling_plan_allocation?.selling_plan?.id;
  const selectedPlan = sortedPlans.find(p => p.id === selectedPlanId) || sortedPlans[0];

  sellingPlanDropdown = `
    <select class="sidecart-selling-plan-select visually-hidden" data-key="${item.key}">
      ${sortedPlans
        .map(plan => `<option value="${plan.id}"${plan.id === selectedPlanId ? ' selected' : ''}>${plan.name}</option>`)
        .join('')}
    </select>
    <div class="custom-dropdown" data-key="${item.key}">
      <button class="custom-dropdown-selected font-degular">
        ${selectedPlan?.name || ''}
        <span class="dropdown-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7073 15.7069C12.5198 15.8943 12.2655 15.9996 12.0003 15.9996C11.7352 15.9996 11.4809 15.8943 11.2933 15.7069L5.63634 10.0499C5.54083 9.95761 5.46465 9.84726 5.41224 9.72526C5.35983 9.60326 5.33225 9.47204 5.33109 9.33926C5.32994 9.20648 5.35524 9.0748 5.40552 8.9519C5.4558 8.829 5.53006 8.71735 5.62395 8.62346C5.71784 8.52957 5.82949 8.45531 5.95239 8.40503C6.07529 8.35475 6.20696 8.32945 6.33974 8.3306C6.47252 8.33176 6.60374 8.35934 6.72575 8.41175C6.84775 8.46416 6.9581 8.54034 7.05034 8.63585L12.0003 13.5859L16.9503 8.63585C17.1389 8.4537 17.3915 8.3529 17.6537 8.35518C17.9159 8.35746 18.1668 8.46263 18.3522 8.64804C18.5376 8.83344 18.6427 9.08426 18.645 9.34645C18.6473 9.60865 18.5465 9.86125 18.3643 10.0499L12.7073 15.7069Z" fill="#262525"/>
          </svg>
        </span>
      </button>
      <ul class="custom-dropdown-list test" style="display:none;">
        ${sortedPlans
          .map(plan => `<li class="custom-dropdown-option" data-value="${plan.id}">${plan.name}</li>`)
          .join('')}
      </ul>
    </div>
  `;
}

      const itemDiv = document.createElement('div');
      itemDiv.className = 'sidecart-item';
      // Stable hooks for scripts reacting to mozi:cart:updated.
      itemDiv.setAttribute('data-line-key', item.key);
      itemDiv.setAttribute('data-variant-id', item.variant_id);
      // Add class if this is a free gift identified by free gift properties
      if (isFreeGiftItem(item)) {
        itemDiv.classList.add('sidecart-addon-product');
      }
      // Remove rewardIds and isAutoAddon logic
      // const rewardIds = [
      //   window.MOZIWASH_REWARD_PRODUCTS?.reward1,
      //   window.MOZIWASH_REWARD_PRODUCTS?.reward2,
      //   window.MOZIWASH_REWARD_PRODUCTS?.reward3
      // ];
      // const isAutoAddon = (
      //   rewardIds.includes(item.variant_id) &&
      //   item.properties && item.properties._auto_addon
      // );
      // if (isAutoAddon) {
      //   itemDiv.classList.add('sidecart-addon-product');
      // }
      // Remove data-has-discount if the item has any discount applied
      const hasDiscount = item.discounts && item.discounts.length > 0;
      let originalTotal = 0;
      const cartHasMultipleItems = cart.items.length >= 2;
      cart.items.forEach(item => {
        originalTotal += item.original_line_price;
      });

      if (hasDiscount) {
        itemDiv.setAttribute('data-has-discount', 'true');
      }
      
      let lineItemPrice = '';
      // If this is a free gift, show $0.00 and Free badge — but only once the
      // discount has actually zeroed the line. Claiming "Free" on a line the
      // customer is still being charged for is worse than showing the price.
      if (isFreeGiftItem(item) && item.final_line_price === 0) {
        lineItemPrice = `
          <div class="sidecart-item-price-row ot-rewarditem">
              <span class="sidecart-item-price">$0.00</span>
              <span class="line-item-free-badge">Free</span>
          </div>
        `;
      }
      // else if(cartHasMultipleItems && !isSubscription){
      //   lineItemPrice = `
      //   <div class="sidecart-item-price-row ot-multipleitems">
      //         <span class="sidecart-item-price">${Shopify.formatMoney(item.price)}</span>
      //         <span class="line-item-discount-badge">Discount applied</span>
      //   </div>
      //   `
      // }
      else{
        lineItemPrice = `
          <div class="sidecart-item-price-row ot-oneitem">
              <span class="sidecart-item-price">${Shopify.formatMoney(item.final_line_price)}</span>
              ${compareAt}
          </div>
        `
      }
    let cartStockBadge = '';

    // Pre-order lines carry a visible "Pre-order" property set by the PDP (CNV-7481).
    const preorderMessage = item.properties?.['Pre-order'];
    const preorderRibbon = preorderMessage ? `<span class="sidecart-preorder-ribbon">Pre-order</span>` : '';
    const preorderNote = preorderMessage ? `<div class="sidecart-preorder-note">Pre-order · ${preorderMessage}</div>` : '';

    const tags = getProductTags(item.handle);
    const cartTags = tags.filter(t => t.toLowerCase().startsWith('cart_'));

    if (cartTags.length && !preorderMessage) {
      const rawTag = cartTags[0];
      const cleanText = rawTag
        .replace(/cart_/i, '')
        .replace(/-/g,' ')
        .toUpperCase();

      let badgeClass = 'cart-badge-yellow';
      const tagText = rawTag.toLowerCase();

      if (tagText.includes('almost')) {
        badgeClass = 'cart-badge-red';
      } else if (tagText.includes('final')) {
        badgeClass = 'cart-badge-red';
      } else if (tagText.includes('selling fast')) {
        badgeClass = 'cart-badge-green';
      } else if (tagText.includes('in stock')) {
        badgeClass = 'cart-badge-blue';
      } else if (tagText.includes('most popular')) {
        badgeClass = 'cart-badge-light-yellow';
      }

      cartStockBadge = `
        <div class="cart-stock-badge ${badgeClass}">
          ${cleanText}
        </div>
      `;
    }
      const itemImage = item.metafields?.custom?.featured_product_image ? item.metafields.custom.featured_product_image : item.image;
      itemDiv.innerHTML = `
        <div class="sidecart-item-img">${preorderRibbon}<img src="${itemImage}" alt="${item.title}" width="60"></div>
        <div class="sidecart-item-info">
          <div class="sidecart-title-price-row">
            <div class="sidecart-item-title-row">
              <span class="sidecart-item-title">${item.product_title}</span> ${tag}
            </div>
            ${lineItemPrice}
          </div>
          <div class="cart-badge-container">${cartStockBadge}</div>
          ${preorderNote}
          <div class="sidecart-item-controls">
            ${sellingPlanDropdown}
                 ${(
  !isSubscription && 
  !(item.properties && item.properties._addon_item) && 
  sellingPlans.length > 0
) ? `
<div class="subscribe-btn-wrapper">
  <button 
    class="subscribe-now-btn"
    data-key="${item.key}"
    data-variant-id="${item.variant_id}">
    Subscribe and save big
  </button>
</div>

` : ''}

            <div class="sidecart-item-qty">
              <div class="sidecart-item-qty-row">
               <button type="button" class="qty-btn" data-qty="-1" data-key="${item.key}">−</button>

                <span>${item.quantity}</span>
                <button type="button" class="qty-btn" data-qty="1" data-key="${item.key}">+</button>
              </div>
              <button type="button" class="remove-btn" data-key="${item.key}">
              <img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/mozi-cart--delete-icon.svg?v=1749934844" alt="Remove" width="12" height="14">
              </button>
            </div>
          </div>
        </div>
      `;
      itemsContainer.appendChild(itemDiv);
    });
    attachSubscribeNowHandler();
    // Add event listeners for qty and remove
  itemsContainer.querySelectorAll('.qty-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const itemDiv = this.closest('.sidecart-item');
    const qtySpan = itemDiv.querySelector('.sidecart-item-qty span');
    let currentQty = parseInt(qtySpan.textContent, 10);
    let change = parseInt(this.dataset.qty, 10);
    let newQty = currentQty + change;

    // Allow quantity to go down to 0
    if (newQty < 0) newQty = 0;

    // Optimistic UI update
    qtySpan.textContent = newQty;
    showSpinner();
    updateQty(this.dataset.key, newQty, itemDiv, currentQty);
     });
});

    itemsContainer.querySelectorAll('.remove-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const itemDiv = this.closest('.sidecart-item');
        showSpinner();
        updateQty(this.dataset.key, 0, itemDiv, parseInt(itemDiv.querySelector('.sidecart-item-qty span').textContent, 10));
      });
    });

    // Add event listeners for custom dropdowns
    itemsContainer.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      const button = dropdown.querySelector('.custom-dropdown-selected');
      const list = dropdown.querySelector('.custom-dropdown-list');
      const select = dropdown.previousElementSibling; // the hidden select

      // Toggle dropdown
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const dropdown = button.closest('.custom-dropdown');
        const list = dropdown.querySelector('.custom-dropdown-list');
        const isOpen = list.style.display === 'block';
        list.style.display = isOpen ? 'none' : 'block';
        dropdown.classList.toggle('open', !isOpen);
      });

      // Option click
      list.querySelectorAll('.custom-dropdown-option').forEach(option => {
        option.addEventListener('click', () => {
          // Update custom UI
          button.innerHTML = option.textContent + `<span class="dropdown-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7073 15.7069C12.5198 15.8943 12.2655 15.9996 12.0003 15.9996C11.7352 15.9996 11.4809 15.8943 11.2933 15.7069L5.63634 10.0499C5.54083 9.95761 5.46465 9.84726 5.41224 9.72526C5.35983 9.60326 5.33225 9.47204 5.33109 9.33926C5.32994 9.20648 5.35524 9.0748 5.40552 8.9519C5.4558 8.829 5.53006 8.71735 5.62395 8.62346C5.71784 8.52957 5.82949 8.45531 5.95239 8.40503C6.07529 8.35475 6.20696 8.32945 6.33974 8.3306C6.47252 8.33176 6.60374 8.35934 6.72575 8.41175C6.84775 8.46416 6.9581 8.54034 7.05034 8.63585L12.0003 13.5859L16.9503 8.63585C17.1389 8.4537 17.3915 8.3529 17.6537 8.35518C17.9159 8.35746 18.1668 8.46263 18.3522 8.64804C18.5376 8.83344 18.6427 9.08426 18.645 9.34645C18.6473 9.60865 18.5465 9.86125 18.3643 10.0499L12.7073 15.7069Z" fill="#262525"/>
            </svg>
          </span>`;
          list.style.display = 'none';
          // Update hidden select
          select.value = option.dataset.value;
          // Trigger change event for your logic
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Optional: close dropdown on outside click
      document.addEventListener('click', (e) => {
        if (!dropdown.contains(e.target)) {
          list.style.display = 'none';
        }
      });
    });

    // Add event listener for selling plan dropdowns (hidden select)
    itemsContainer.querySelectorAll('.sidecart-selling-plan-select').forEach(select => {
      select.addEventListener('change', function() {
        const key = this.dataset.key;
        const newPlanId = parseInt(this.value, 10);
        this.disabled = true;
        showSpinner();
        // Find the current item to get the quantity
        const item = cart.items.find(i => i.key === key);
        if (!item) return;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            id: key,
            quantity: item.quantity,
            selling_plan: newPlanId
          })
        })
        .then(res => {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(applyCartResponse)
        .catch(() => {
          // alert('Could not update subscription frequency. Please try again.');
          fetchCart();
        })
        .finally(() => {
          this.disabled = false;
          hideSpinner();
        });
      });
    });

    // Update progress bar after rendering items
    // updateProgressBarContent(cart);
    updateProgressBar(cart);
    // renderUpsells(cart); // Upsells not used, skip rendering for performance
    setupRecommendATC();

    // --- Cart-level (order) discount message ---
    const discountApps = cart.cart_level_discount_applications || [];
    let totalCartLevelDiscount = 0;
    discountApps.forEach(app => {
      totalCartLevelDiscount += app.total_allocated_amount;
    });
    // Remove any previous message
    let discountMsg = document.getElementById('sidecart-bundle-discount-msg');
    if (discountMsg) discountMsg.remove();
    if (totalCartLevelDiscount > 0) {
      discountMsg = document.createElement('div');
      discountMsg.id = 'sidecart-bundle-discount-msg';
      discountMsg.className = 'sidecart-bundle-discount-msg';
      discountMsg.innerHTML = `<span>Bundle discount:</span> <span class="sidecart-bundle-discount-amt">-${Shopify.formatMoney(totalCartLevelDiscount)}</span>`;
      // Insert above .sidecart-total in the footer
      const sidecartTotal = document.querySelector('.sidecart-total');
      if (sidecartTotal && sidecartTotal.parentNode) {
        sidecartTotal.parentNode.insertBefore(discountMsg, sidecartTotal);
      }
    }

    // --- Dynamic Reward Management ---
    // (REMOVED: All reward/addon logic is now handled by 3rd party app)

    // Addon cart note updater
    //updateCartNoteWithAddons(cart);
  }
     // Setup ATC for bestsellers
      document.querySelectorAll('.sidecart-bestseller-btn').forEach(btn => {
        btn.addEventListener('click', function () {
          const variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            alert('No variant ID found!');
            this.disabled = false;
            this.textContent = 'ADD TO CART';
            return;
          }
          this.disabled = true;
          this.textContent = 'ADDING...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1, selling_plan: null })
          })
            .then(res => {
              if (!res.ok) {
                return res.json().then(data => {
                  throw new Error(data.description || 'Add to cart failed');
                });
              }
              return fetchCart();
            })
            .then(() => {
              this.disabled = false;
              this.textContent = 'ADD TO CART';
            })
            .catch(err => {
              this.disabled = false;
              this.textContent = 'ADD TO CART';
              // alert('Could not add item. ' + (err.message || 'Please try again.'));
              // console.error('ATC error:', err);
            });
        });
      });

  // Update quantity or remove (with optimistic UI and revert on error)
  function updateQty(key, qty, itemDiv, prevQty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    })
    .then(res => {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    })
    // change.js already answered with the whole cart — painting it here is what
    // keeps a quantity click at one round trip instead of two.
    .then(applyCartResponse)
    .catch((err) => {
      // Revert UI
      if (itemDiv && prevQty !== undefined) {
        const qtySpan = itemDiv.querySelector('.sidecart-item-qty span');
        if (qtySpan) qtySpan.textContent = prevQty;
      }
      // console.error('Cart update error:', err);
      // alert('Could not update cart. Please try again.');
      fetchCart();
    })
    .finally(hideSpinner);
  }

//////////////////////////////////////////////////
// Cart subscribe now button js start here for single products
function attachSubscribeNowHandler() {
  document.querySelectorAll('.subscribe-now-btn').forEach(btn => {
    btn.addEventListener('click', handleSubscribeNowClick);
  });
}

function handleSubscribeNowClick(e) {

  const btn = e.currentTarget;
  const key = btn.dataset.key;
  const variantId = btn.dataset.variantId;

  const itemDiv = btn.closest('.sidecart-item');
  const qtySpan = itemDiv.querySelector('.sidecart-item-qty span');
  const currentQty = parseInt(qtySpan.textContent, 10) || 1;

  btn.disabled = true;
  btn.textContent = 'Updating...';
  showSpinner();

  const planId = getDefaultSellingPlanId(variantId);
  if (!planId) {
    console.error('No selling plan found for variant', variantId);
    btn.textContent = 'Error';
    btn.disabled = false;
    hideSpinner();
    return;
  }

  // Remove one-time product, then add subscription product. Only the "Pre-order"
  // note is carried over: other properties (e.g. "Purchase Type: One Time" from
  // the dryer LP, gift markers) must not follow the line onto a subscription.
  let properties = {};
  resolveCart()
    .then(cart => {
      const preorder = cart.items.find(i => i.key === key)?.properties?.['Pre-order'];
      if (preorder) properties = { 'Pre-order': preorder };
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    })
    .then(() => fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: currentQty,
        selling_plan: planId,
        properties
      })
    }))
    .then(res => res.json())
    .then(() => {
      fetchCart();
      hideSpinner();
    })
    .catch(err => {
      console.error('Error updating to subscription:', err);
      btn.textContent = 'Error';
      btn.disabled = false;
      hideSpinner();
    });
}

// Cart subscribe now button js end here

///////////////////////////////////////////////
  // Checkout button
  checkoutBtn.addEventListener('click', function() {
    window.location.href = '/checkout';
  });

  // Utility: Shopify money format fallback
  if (!window.Shopify || !Shopify.formatMoney) {
    window.Shopify = window.Shopify || {};
    Shopify.formatMoney = function(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

 

function updateProgressBar(cart) {
  const fill = document.querySelector('.sidecart-progress-fill');
  const marker0 = document.querySelector('.sidecart-progress-marker.marker-0');
  const marker1 = document.querySelector('.sidecart-progress-marker.marker-1');
  const marker2 = document.querySelector('.sidecart-progress-marker.marker-2');
  const text = document.querySelector('.sidecart-progress-text');

  // Check if cart has subscription items
  const hasSubscriptionItems = (cart.items || []).some(
    item => item.selling_plan_allocation
  );

  // Handle visibility of wrappers
  const progressWrapper = document.querySelector('.sidecart-progress-section');
  const onetimewrapper = document.querySelector('.onetime-progress-bar');
      if (!hasSubscriptionItems) {
      // ONE-TIME case
      if (progressWrapper) {
        progressWrapper.style.display = '';
        progressWrapper.classList.add('onetime-progress'); // add class for one-time
      }

      if (onetimewrapper) onetimewrapper.style.display = '';

    } else {
      // SUBSCRIPTION case
      if (progressWrapper) {
        progressWrapper.style.display = '';
        progressWrapper.classList.remove('onetime-progress'); // remove class for subscription
      }

      if (onetimewrapper) onetimewrapper.style.display = 'none';
    }

  // Count only subscription items
  const realItemCount = (cart.items || [])
    .filter(item => !(item.properties && (isFreeGiftItem(item) || item.properties._addon_item)))
    .filter(item => {
      const ids = window.SIDECART_DETERGENT_PRODUCT_IDS;
      return Array.isArray(ids) && ids.length
        ? ids.includes(item.product_id)
        : true;
    })
    .filter(item => item.selling_plan_allocation)
    .reduce((sum, item) => {
      let count = item.quantity;
      const productType = (item.product_type || '').toLowerCase();

      // ✅ Adjust count for bundle types
      if (productType.includes('2pack')) {
        count = 2 * item.quantity;
      } else if (productType.includes('4pack')) {
        count = 4 * item.quantity;
      } else if (productType.includes('3pack')) {
        // Treat LimitedEdition as 3-Pack
        count = 3 * item.quantity;
      }

      return sum + count;
    }, 0);

  // Progress thresholds
  const markerThresholds = [1, 2, 4];
  const totalMarkers = 3;
  let reachedMarkers = markerThresholds.filter(th => realItemCount >= th).length;

  // Reset & update markers
  [marker0, marker1, marker2].forEach(marker => marker?.classList.remove('reached'));
  if (marker0 && realItemCount >= 1) marker0.classList.add('reached');
  if (marker1 && realItemCount >= 2) marker1.classList.add('reached');
  if (marker2 && realItemCount >= 4) marker2.classList.add('reached');

  // Progress bar fill logic
  let fillWidth = '2%';
  if (realItemCount >= 4) {
    fillWidth = '100%';
  } else if (realItemCount === 3) {
    fillWidth = '75%';
  } else if (realItemCount === 2) {
    fillWidth = '50%';
  } else if (realItemCount === 1) {
    fillWidth = '12%';
  }

  if (fill) fill.style.width = fillWidth;

  // Progress text logic
  let msg = '';
  if (window.SIDECART_PROGRESS_MARKER_MSGS) {
    if (realItemCount >= 4) {
      msg = window.SIDECART_MAX_DISCOUNTS_MSG || 'YOU HAVE UNLOCKED MAX DISCOUNTS!!! 🎉';
    } else if (realItemCount === 1) {
      msg = window.SIDECART_PROGRESS_MARKER_MSGS[0];
    } else if (realItemCount === 2) {
      msg = window.SIDECART_PROGRESS_MARKER_MSGS[1];
    } else if (realItemCount === 3) {
      msg = window.SIDECART_PROGRESS_MARKER_MSGS[2];
    }
  }

  if (text) text.innerHTML = msg;
}

  // Update progress bar content based on cart type (subscription vs one-time)
  function updateProgressBarContent(cart) {
    // Always use one-time progress bar content
    const levelLabels = window.SIDECART_LEVEL_LABELS || [];
    const markerMessages = window.SIDECART_PROGRESS_MARKER_MSGS || [];
    const maxDiscountsMsg = window.SIDECART_MAX_DISCOUNTS_MSG || 'YOU HAVE UNLOCKED MAX DISCOUNTS!!! 🎉';
    
    // Update progress bar labels
    const progressLabels = document.querySelectorAll('.sidecart-progress-label');
    progressLabels.forEach((label, index) => {
      if (levelLabels[index]) {
        const amountSpan = label.querySelector('.amount');
        const subtextSpan = label.querySelector('.subtext');
        
        if (amountSpan) amountSpan.innerHTML = levelLabels[index].label;
        if (subtextSpan) subtextSpan.textContent = levelLabels[index].subtext;
      }
    });
    
    // Store the current marker messages and max discounts message for use in updateProgressBar
    window.SIDECART_PROGRESS_MARKER_MSGS = markerMessages;
    window.SIDECART_MAX_DISCOUNTS_MSG = maxDiscountsMsg;
  }

  // Move setupRecommendATC inside DOMContentLoaded
  function setupRecommendATC() {
    document.querySelectorAll('.sidecart-recommend-btn').forEach(btn => {
      btn.addEventListener('click', function () {
         btn.classList.add('loading');
        const variantId = this.getAttribute('data-variant-id');
        if (!variantId) {
          // alert('No variant ID found!');
          this.disabled = false;
          this.textContent = 'ADD TO CART';
          return;
        }

        this.disabled = true;
        this.textContent = 'ADDING...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, selling_plan: null })
        })
          .then(res => {
            if (!res.ok) {
              return res.json().then(data => {
                throw new Error(data.description || 'Add to cart failed');
              });
            }
            return fetchCart(); // Now fetchCart is in scope
          })
          .then(() => {
            this.disabled = false;
            this.textContent = 'ADD TO CART';
          })
          .catch(err => {
            this.disabled = false;
            this.textContent = 'ADD TO CART';
            // alert('Could not add item. ' + (err.message || 'Please try again.'));
            // console.error('ATC error:', err);
          })
           .finally(() => {
      // --- Hide loader ---
      btn.classList.remove('loading');
    });
      });
    });
  }

  // Addon cart note updater
  function updateCartNoteWithAddons(cart) {
    const addonNames = cart.items
      .filter(item => item.properties && item.properties._auto_addon)
      .map(item => item.product_title)
      .filter(Boolean);
    const note = addonNames.length
      ? 'Add-on items: ' + addonNames.join(', ')
      : '';
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note })
    });
  }

    window.openSidecart = openSidecart;
    window.fetchCart = fetchCart;

});
 

 

